"use strict";

exports.__esModule = true;
exports.DashboardCollection = DashboardCollection;
var _react = _interopRequireDefault(require("react"));
var _API = require("../../API");
var _useAiDraftsStore = require("../../AI/Authoring/useAiDraftsStore");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Provides access to dashboards via a render prop.
 */
function DashboardCollection(props) {
  var localStore = (0, _useAiDraftsStore.useAiDraftsStore)("dashboards");
  return /*#__PURE__*/_react["default"].createElement(_API.Collection, {
    baseURL: "/api/v3/ui-config/dashboards",
    itemBaseURL: "/api/v3/ui-config/dashboards/:id",
    localStore: localStore
  }, props.children);
}